import type {
    IMembersWork,
    ISchedulesWork,
    IStatisticsWork,
    ITasksWork,
    IWorkGroup,
    IWorkGroupPage,
    IWorkGroupRequest,
} from '../../types/tenant/workGroup.types'
import { baseApi } from '../baseApi'
import type { ResponseType } from '../types'

const webBase = '/api/tenants/groups'

export const workGroups = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAllWorkGroups: builder.query<ResponseType<IWorkGroup[]>, string>({
            query: qwery => `${webBase}?${qwery}`,
            providesTags: ['workGroups'],
        }),
        getGroupSchedules: builder.query<
            ResponseType<ISchedulesWork>,
            { id: string | number; qwery: string }
        >({
            query: ({ id, qwery }) => `${webBase}/${id}/schedules?${qwery}`,
            providesTags: ['workGroups'],
        }),
        getGroupHeader: builder.query<
            ResponseType<IWorkGroupPage>,
            string | number
        >({
            query: id => `${webBase}/${id}/header`,
            providesTags: ['workGroups'],
        }),
        getGroupTasks: builder.query<
            ResponseType<ITasksWork>,
            { id: string | number; qwery: string }
        >({
            query: ({ id, qwery }) => `${webBase}/${id}/tasks?${qwery}`,
            providesTags: ['workGroups'],
        }),
        getGroupMembers: builder.query<
            ResponseType<IMembersWork>,
            { id: string | number; qwery: string }
        >({
            query: ({ id, qwery }) => `${webBase}/${id}/members?${qwery}`,
            providesTags: ['workGroups'],
        }),
        getGroupStatistics: builder.query<
            ResponseType<IStatisticsWork>,
            { id: string | number; qwery: string }
        >({
            query: ({ id, qwery }) => `${webBase}/${id}/statistics?${qwery}`,
            providesTags: ['workGroups'],
        }),
        createWorkGroups: builder.mutation<
            ResponseType<IWorkGroup>,
            IWorkGroupRequest
        >({
            query: body => ({
                url: `${webBase}`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['workGroups'],
        }),
        updateWorkGroups: builder.mutation<
            ResponseType<IWorkGroup>,
            { groupId: string | number; body: IWorkGroupRequest }
        >({
            query: ({ groupId, body }) => ({
                url: `${webBase}/${groupId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['workGroups'],
        }),
        deleteWorkGroups: builder.mutation<
            ResponseType<IWorkGroup>,
            number | string
        >({
            query: teamId => ({
                url: `${webBase}/${teamId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['workGroups'],
        }),
    }),
})

export const {
    useCreateWorkGroupsMutation,
    useDeleteWorkGroupsMutation,
    useGetAllWorkGroupsQuery,
    useLazyGetAllWorkGroupsQuery,
    useUpdateWorkGroupsMutation,
    useGetGroupMembersQuery,
    useGetGroupSchedulesQuery,
    useGetGroupStatisticsQuery,
    useGetGroupTasksQuery,
    useGetGroupHeaderQuery,
} = workGroups
